import { Outlet } from 'react-router';

export default function DashboardsLayout() {
  return <Outlet />;
}
